/**
 * Obtém uma imagem por URL no browser e devolve data URL (base64).
 * Falha com CORS se o servidor da imagem não permitir origem da app.
 */
export async function fetchImageAsDataUrl(urlString) {
  const trimmed = String(urlString || '').trim()
  if (!trimmed) {
    throw new Error('Informe uma URL.')
  }
  let u
  try {
    u = new URL(trimmed)
  } catch {
    throw new Error('URL inválida.')
  }
  if (!/^https?:$/i.test(u.protocol)) {
    throw new Error('Use uma URL http ou https.')
  }

  let res
  try {
    res = await fetch(trimmed, { mode: 'cors', credentials: 'omit', cache: 'no-store' })
  } catch {
    throw new Error(
      'Não foi possível aceder à URL (rede ou bloqueio CORS). Tente um ficheiro local ou outro endereço que permita pedidos do navegador.',
    )
  }
  if (!res.ok) {
    throw new Error(`Não foi possível obter a imagem (HTTP ${res.status}).`)
  }
  const ct = (res.headers.get('content-type') || '').split(';')[0].trim().toLowerCase()
  if (!ct.startsWith('image/')) {
    throw new Error('O endereço não devolveu um tipo image/*.')
  }
  const blob = await res.blob()
  return await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '')
    reader.onerror = () => reject(new Error('Falha ao ler a imagem.'))
    reader.readAsDataURL(blob)
  })
}
